import * as marietta from "../../..";
import { Dialog } from "../../../core/view";
import { AdditionalPinData } from "../../manager/AddLidarPinManager";

export class PinConfirm extends Dialog {

    private itemList: marietta.webcad.item.FreeText[] = [];

    private data: AdditionalPinData | null = null;

    constructor(draggable: boolean) {
        super(draggable);
    }

    public buildContent() {
        const id = 'PinConfirm';

        const title = (marietta.webcad.WebCADGlobal.language === 'jp') ? '確認' : 'Confirm';

        let contents = 'この階にはすでにピンが配置されています。<br>すべてのピンを削除して、新しくピンを取り込みますか？';

        let footer = '<button id="btnOK" style="padding-left: 5px;padding-right: 5px;"><span class="jp">削除して追加</span><span class="en">Delete and Add</span></button>';
        footer += '<button id="btnOverwrite"><span class="jp">追加</span><span class="en">overwrite</span></button>';
        footer += '<button id="btnCancel"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>';

        this.createDialog(id, title, contents, footer);

        document.getElementById('btnOK')?.addEventListener('click', this.okFunc);
        document.getElementById('btnOverwrite')?.addEventListener('click', this.overwriteFunc);
        document.getElementById('btnCancel')?.addEventListener('click', this.close);
    }

    private okFunc = () => {
        for (let i:number = 0; i < this.itemList.length; i++) {
            this.itemList[i].deleteMe();
        }

        if (this.data === null) return;
        marietta.webcad.WebCADGlobal.lidarAddPinManager.startImportWizard(this.data);
    }

    private overwriteFunc = () => {
        if (this.data === null) return;
        marietta.webcad.WebCADGlobal.lidarAddPinManager.startImportWizard(this.data);
    }
}